import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "destinationPackage",
  title: "Package",
  type: "object",
  preview: {
    select: {
      title: "name"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  },
  fields: [
    {
      name: "name",
      title: "Name",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "items",
      title: "Items",
      type: "array",
      of: [{ type: "destinationPackageItem" }]
    },
    {
      name: "showSpecialCruisesFilterLink",
      title: "Show Special Cruises Filter Link",
      type: "boolean",
      options: {
        layout: "checkbox"
      }
    }
  ]
});
